export function getRoundedBorder(roundedBorder) {
  if (!roundedBorder || roundedBorder === "none" || roundedBorder === "rounded-none") {
    return "";
  }
  
  // Backend values should already be valid Tailwind classes (e.g., "rounded-md")
  // But handle any legacy or edge cases
  const validRoundedClasses = [
    "rounded-sm", "rounded-md", "rounded-lg", "rounded-xl", 
    "rounded-2xl", "rounded-3xl", "rounded-full"
  ];
  
  if (validRoundedClasses.includes(roundedBorder)) {
    return roundedBorder;
  }
  
  // Fallback for any unexpected values
  console.warn(`Unexpected rounded border value: ${roundedBorder}`);
  return "";
}

export function getContainerStyleClasses(containerStyle) {
  if (!containerStyle) {
    return "";
  }
  
  const classes = [];
  
  // Handle rounded borders
  const roundedClass = getRoundedBorder(containerStyle.rounded_border);
  if (roundedClass) {
    classes.push(roundedClass);
  }
  
  // Handle internal (inset) shadow
  const internalEnabled = Boolean(containerStyle.shadow_internal_enabled);
  const internalSize = Number(containerStyle.shadow_internal_size || 0);
  if (internalEnabled && internalSize > 0) {
    const insetClassMap = {
      1: "inset-shadow-2xs",
      2: "inset-shadow-xs",
      3: "inset-shadow-sm",
      4: "inset-shadow-md",
      5: "inset-shadow-lg",
      6: "inset-shadow-xl",
      7: "inset-shadow-2xl",
      8: "inset-shadow-3xl",
    };
    const insetClass = insetClassMap[internalSize];
    if (insetClass) {
      classes.push(insetClass);
    }
  }
  
  // Future: Add other container style properties here
  // e.g., borders, shadows, etc.
  
  return classes.filter(Boolean).join(" ");
}

// Returns only the inset shadow class for background layer application
export function getContainerInsetShadowClass(containerStyle) {
  if (!containerStyle) return "";
  const internalEnabled = Boolean(containerStyle.shadow_internal_enabled);
  const internalSize = Number(containerStyle.shadow_internal_size || 0);
  if (!internalEnabled || internalSize <= 0) return "";
  const insetClassMap = {
    1: "inset-shadow-2xs",
    2: "inset-shadow-xs",
    3: "inset-shadow-sm",
    4: "inset-shadow-md",
    5: "inset-shadow-lg",
    6: "inset-shadow-xl",
    7: "inset-shadow-2xl",
    8: "inset-shadow-3xl",
  };
  return insetClassMap[internalSize] || "";
}
